module.exports = __webpack_public_path__ + "img/netflix-logo.176b5a27.svg";